import classnames from 'classnames'
import toPairs from 'lodash/toPairs'
import * as React from 'react'
import { connect } from 'react-redux'
import * as App from '../../../app'
import * as CommunityConfig from '../../../pages/community-config'
import * as Router from '../../../router'
import * as Link from '../../link'
import * as User from '../../user'
import * as Menu from '../constants'
import * as Actions from './actions'
import './styles.css'
import * as Types from './types'

type StateProps = Types.WrappedState & App.WrappedState & CommunityConfig.CommunitiesWrappedState

interface DispatchProps {
  push: (href: string) => Router.PushAction
  toggleUserMenu: () => Types.ToggleUserMenuAction
}
type Props = DispatchProps & StateProps

export const UserMenu = ({ app, communities, toggleUserMenu, userMenu}: Props) =>
<div className="user-info-menu" onClick={toggleUserMenu}>
  <p className="user-text">{userMenu.user.first_name ? userMenu.user.first_name : 'User'}</p>
  <i className="fas fa-caret-down icon"></i>
  <ul className={classnames('user-info-menu-content', {'show-usermenu': userMenu.isOpen})}>
    <li><span>{userMenu.user.first_name} {userMenu.user.last_name}</span></li>
    <li><span>{userMenu.user.email_address}</span></li>
  { toPairs(communities).length > 1 &&
    <div className="top-border">
      <span>
        <li>
          <Link.AnchorLink href={Menu.ADMIN_COMMUNITIES_URL}>Select a newsletter</Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={Menu.REPORTS_ENGAGEMENT_URL}>Engagement</Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={Menu.ADMIN_DOMAIN_DELIVERABILITY_SUMMARY_URL}> Domain Deliverability </Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={Menu.ADMIN_ENGAGEMENT_SUMMARY_URL}>Deliverability Summary</Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={Menu.ADMIN_NEWSBRIEF_COUNTS_URL}>Newsletter Summaries</Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={Menu.ADMIN_NEWSBRIEF_SUMMARY_URL}>Newsletter Summary</Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={Menu.ADMIN_UPCOMING_SCHEDULES_URL}>Upcoming Schedules</Link.AnchorLink>
        </li>
      </span>
    </div>
  }
  { User.hasRole(userMenu.user, User.ADMIN_ROLE) &&
    <div className="top-border">
      <span>
        <li>
          <Link.AnchorLink href={Menu.USERS_URL_HOME}>Manage Users</Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={Menu.ADMIN_REPORTS_URL}>Manage Reports</Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={Menu.CONTENT_IMPORTS_URL}>Imports</Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={`${Menu.COMMUNITY_CONFIG_URL}/${app.selectedCommunity}`}>
            Edit Configuration
          </Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={`${Menu.CONTENT_FILTERGROUPS_URL}`}>Filter Groups</Link.AnchorLink>
        </li>
      </span>
    </div>
  }
  { User.isRasaAdmin(userMenu.user) &&
    <div className="top-border">
      <span>
        <li>
          <Link.AnchorLink href={Menu.ADMIN_DROPS_URL}>Manage Drops</Link.AnchorLink>
       </li>
        <li>
          <Link.AnchorLink href={Menu.ADMIN_FEEDBACK_URL}>View feedback</Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={Menu.ADMIN_EXCLUDED_URL}>Image Exclude List</Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={Menu.ADMIN_USERS_URL}>Manage All Users</Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={Menu.ADMIN_IP_POOLS_URL}>Manage Ip Pools</Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={Menu.ADMIN_DOMAIN_AUTH_URL}>Domain Authentication</Link.AnchorLink>
        </li>
        <li>
          <Link.AnchorLink href={Menu.REPORTS_ONBOARDING_SESSIONS}>Onboarding Sessions</Link.AnchorLink>
        </li>
      </span>
    </div>
  }
    <div className="top-border">
      <span>
        <li>
          <Link.AnchorLink href={Menu.USER_SETTINGS_URL}>User Settings</Link.AnchorLink>
        </li>
      </span>
    </div>
    <div className="top-border">
      <span>
        <li className="text-left">
          <a target="_blank" rel="noopener noreferrer" href={Menu.HELP_URL}>Help</a>
        </li>
      </span>
    </div>
    <div className="top-border">
      <span>
        <li className="text-right">
          <Link.AnchorLink href={Menu.AUTH_LOGOUT_URL}>Sign Out</Link.AnchorLink>
        </li>
      </span>
    </div>
  </ul>
</div>

export const UserMenuConnected = connect(
  ({ app, communities, userMenu }: StateProps) => ({app, communities, userMenu}),
  {
    push: Router.push,
    toggleUserMenu: Actions.toggleUserMenu,
   },
)(UserMenu)



// WEBPACK FOOTER //
// ./src/components/menu/user-menu/component.tsx